

















import { Component, Prop } from 'vue-property-decorator'
import Vue from 'vue'
import HdsIcon from '@/components/HdsIcon.vue'
import HdsBtn from '@/components/HdsBtn.vue'

export const HADES_CHIP_SIZE = {
  XSMALL: 'xs',
  SMALL: 'sm',
  BASE: 'base',
  LARGE: 'lg',
  XLARGE: 'xl',
}

/**
 * 칩 컴포넌트 입니다. 태그나 객체등을 표현할때 사용합니다.
 * 슬롯으로 사용합니다.
 */
@Component({
  components: { HdsIcon, HdsBtn },
})
export default class HdsChip extends Vue {
  name = 'HdsChip'

  /**
   * 비활성화 여부입니다.
   */
  @Prop({
    type: Boolean,
  })
  disabled?: boolean

  /**
   * Close 버튼의 유무입니다.
   */
  @Prop({
    type: Boolean,
    default: false,
  })
  close!: boolean

  /**
   * Close 버튼의 아이콘을 변경가능합니다. https://materialdesignicons.com/
   */
  @Prop({
    type: String,
    default: 'close-circle',
  })
  mdi!: string

  /**
   * Primary 컬러셋을 사용합니다.
   */
  @Prop({
    type: Boolean,
    default: false,
  })
  primary!: boolean

  /**
   * Secondary 컬러셋을 사용합니다.
   */
  @Prop({
    type: Boolean,
    default: false,
  })
  secondary!: boolean

  /**
   * 레이블 스타일을 사용합니다.
   */
  @Prop({
    type: Boolean,
  })
  label?: boolean

  /**
   * 외곽선 스타일을 사용합니다.
   */
  @Prop({
    type: Boolean,
    default: false,
  })
  outlined!: boolean

  /**
   * 텍스트 스타일을 사용합니다.
   */
  @Prop({
    type: Boolean,
    default: false,
  })
  text!: boolean

  /**
   * 대문자로 변환합니다.
   */
  @Prop({
    type: Boolean,
    default: false,
  })
  uppercase!: boolean

  /**
   * 크기를 선택합니다.
   */
  @Prop({
    type: String,
    default: HADES_CHIP_SIZE.BASE,
    validator: function (value) {
      return Object.values(HADES_CHIP_SIZE).indexOf(value) !== -1
    },
  })
  size!: string

  /**
   * 색을 지정합니다.
   */
  @Prop({
    type: String,
  })
  color?: string

  /**
   * 테두리 색을 지정합니다.
   */
  @Prop({
    type: String,
  })
  boxShadowColor?: string

  /**
   * 배경색을 지정합니다.
   */
  @Prop({
    type: String,
  })
  backgroundColor?: string

  get classes() {
    return {
      'hds-chip': true,
      'hds-disabled': this.disabled,
      'hds-chip--primary': this.primary,
      'hds-chip--secondary': this.secondary,
      'hds-chip--label': this.label,
      'hds-chip--outlined': this.outlined,
      'hds-chip--text': this.text,
      [`hds-size--${this.size}`]: true,
      'hds-chip--uppercase': this.uppercase,
    }
  }

  get styles() {
    return {
      color: this.color,
      backgroundColor: this.backgroundColor,
      boxShadow: `0px 0px 0px 1px ${this.boxShadowColor}`,
    }
  }

  onClickClose(evt: Event) {
    this.$emit('click:close', evt)
  }

  onMousedownClose(evt: Event) {
    this.$emit('mousedown:close', evt)
  }

  onMouseupClose(evt: Event) {
    this.$emit('mouseup:close', evt)
  }
}
